import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRecurringJournals,
  saveRecurringJournal,
  deleteRecurringJournal,
} from "./recurringJournalThunk";

const initialState = {
  list:              [],
  loading:           false,
  saving:            false,
  selectedRecurring: null,
  isEdit:            false,
  refreshList:       false,
};

const recurringJournalSlice = createSlice({
  name: "recurringJournals",
  initialState,
  reducers: {
    resetRecurringJournals: (state) => {
      state.list    = [];
      state.loading = false;
    },
    setSelectedRecurring: (state, action) => {
      state.selectedRecurring = action.payload;
    },
    setIsEditRecurring: (state, action) => {
      state.isEdit = action.payload;
    },
    setRefreshRecurringList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch list
    builder.addCase(fetchRecurringJournals.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRecurringJournals.fulfilled, (state, action) => {
      state.loading = false;
      state.list    = action.payload;
    });
    builder.addCase(fetchRecurringJournals.rejected, (state) => {
      state.loading = false;
    });

    // save
    builder.addCase(saveRecurringJournal.pending, (state) => {
      state.saving = true;
    });
    builder.addCase(saveRecurringJournal.fulfilled, (state) => {
      state.saving = false;
    });
    builder.addCase(saveRecurringJournal.rejected, (state) => {
      state.saving = false;
    });

    // delete
    builder.addCase(deleteRecurringJournal.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteRecurringJournal.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteRecurringJournal.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  resetRecurringJournals,
  setSelectedRecurring,
  setIsEditRecurring,
  setRefreshRecurringList,
} = recurringJournalSlice.actions;

export default recurringJournalSlice.reducer;